/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query PressoverviewQuery($uid: String!) {
    prismic {
      pressoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_PressoverviewBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_PressoverviewBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_PressoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_PressoverviewBodyPressnews {
          type
            label
            fields {
              sub_article_company_name
              sub_article_date
              sub_article_title
              sub_article_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
            }
            primary {
              background_color
              background_image
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              main_article_company_name
              main_article_content
              main_article_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              main_article_content_color
              main_article_date
              main_article_title
              main_article_logo
              main_article_title_color
              sub_article_title_color
              subheading
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_PressoverviewBodyPresstoptabbedleftnavcontent {
          type
label
fields {
  company
  date1
  link_text
  link_url {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  top_tab_relation
  year
}
primary {
  background_color
  heading
  heading_color
  text_color
  top_tab_1
  top_tab_2
}
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Pressoverview = ({ data, location }) =>
  data.prismic.pressoverview ? (
    <MainLayout location={location} layout='pressoverview'>
    <Helmet>
      <title>{(data.prismic.pressoverview.title[0] && data.prismic.pressoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.pressoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.pressoverview.path : 'https://www.digitalocean.com' + data.prismic.pressoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.pressoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.pressoverview.title[0] ? data.prismic.pressoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.pressoverview.description ? data.prismic.pressoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.pressoverview.open_graph_image ? data.prismic.pressoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.pressoverview.description ? data.prismic.pressoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.pressoverview.title[0] ? data.prismic.pressoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.pressoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.pressoverview.path : 'https://www.digitalocean.com' + data.prismic.pressoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.pressoverview.open_graph_image ? data.prismic.pressoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.pressoverview.body} />
    </MainLayout>
  ) : null;

Pressoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Pressoverview;
